/* eslint-disable */

/** unique or primary key constraints on table "argo.schedule_event" */
export enum ArgoScheduleEventConstraint {
  /** unique or primary key constraint on columns "schedule_event_id" */
  ScheduleEventPkey = 'schedule_event_pkey'
}

/** select columns of table "argo.schedule_event" */
export enum ArgoScheduleEventSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Day = 'day',
  /** column name */
  EventId = 'event_id',
  /** column name */
  EventTypeId = 'event_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Range = 'range',
  /** column name */
  ScheduleId = 'schedule_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** update columns of table "argo.schedule_event" */
export enum ArgoScheduleEventUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Day = 'day',
  /** column name */
  EventId = 'event_id',
  /** column name */
  EventTypeId = 'event_type_id',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Range = 'range',
  /** column name */
  ScheduleId = 'schedule_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

